<template>
    <ul class="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion" id="accordionSidebar">
        <!-- Sidebar - Brand -->
        <router-link to="/" class="sidebar-brand d-flex align-items-center justify-content-center">
            <div class="sidebar-brand-icon">
<!--                <img src="images/hat_logo.png" width="100px" />-->
            </div>
            <div class="sidebar-brand-text mx-1 h5">
                <strong>{{Lang.get('messages.site_name')}}</strong>
            </div>
        </router-link>

        <!-- Divider -->
        <hr class="sidebar-divider my-0" />

        <!-- Nav Item - Dashboard -->
        <router-link to="/" v-slot="{ href, route, navigate, isActive, isExactActive }">
            <li class="nav-item" :class="[isExactActive && 'active']">
                <a class="nav-link" :href="href" @click="navigate">
                    <i class="fas fa-fw fa-tachometer-alt"></i>
                    <span>{{Lang.get('messages.sidebar.dashboard')}}</span>
                </a>
            </li>
        </router-link>

        <!-- Divider -->
        <hr class="sidebar-divider" />

        <!-- Nav Item - Basic Data -->
        <template v-for="(link, index) in links">
            <hr class="sidebar-divider" :key="index" v-if="link.type" />


            <template>

                <router-link :to="link.path" :key="index" v-slot="{ href, navigate, isExactActive }"
                             v-if="!link.permission || can(PERMISSIONS[link.permission])">
                    <li class="nav-item" :class="[isExactActive && 'active']">
                        <a class="nav-link" :href="href" @click="navigate">
                            <i class="fas fa-fw" :class="link.icon"></i>
                            <span>{{Lang.get(`messages.sidebar.${link.label}`)}}</span>
                        </a>
                    </li>
                </router-link>
<!--                <router-link :to="link.path" :key="index" v-slot="{ href, navigate, isExactActive }"-->
<!--                             v-else>-->
<!--                    <li class="nav-item" :class="[isExactActive && 'active']">-->
<!--                        <a class="nav-link" :href="href" @click="navigate">-->
<!--                            <i class="fas fa-fw" :class="link.icon"></i>-->
<!--                            <span>{{ROLES.TEACHER}}</span>-->
<!--                        </a>-->
<!--                    </li>-->
<!--                </router-link>-->

            </template>
        </template>

    </ul>
</template>

<script>
    export default {
        data() {
            return {
                superAdminLinks: [
                        {
                            label: "grades",
                            path: "/grades",
                            icon: 'fa-graduation-cap',
                            permission: "VIEW_GRADES"
                        },
                        {
                            label: "classes",
                            path: "/classes",
                            icon: 'fa-file-alt',
                            permission: "VIEW_CLASSES"
                        },
                        {
                            label: "classrooms",
                            path: "/classrooms",
                            icon: 'fa-building',
                            permission: "VIEW_CLASSROOMS"
                        },
                        {
                            label: "subjects",
                            path: "/subjects",
                            icon: 'fa-book-open',
                            permission: "VIEW_SUBJECTS"
                        },
                        {
                            label: "schools",
                            path: "/schools",
                            icon: 'fa-warehouse',
                            permission: "VIEW_SCHOOLS"
                        },
                        {
                            label: "teachers",
                            path: "/teachers",
                            icon: 'fa-user-tie',
                            permission: "VIEW_TEACHERS"
                        },
                        {
                            label: "students",
                            path: "students",
                            icon: 'fa-user-friends',
                            permission: "VIEW_USERMOBILES"
                        },
                        {
                            label: "parents",
                            path: "parents",
                            icon: 'fa-user-friends',
                            permission: "VIEW_USERMOBILES"
                        },
                        {
                            type: 'break'
                        },
                        {
                            label: "notifications",
                            path: "/notifications",
                            icon: 'fa-user-tie',
                            permission: "VIEW_NOTIFICATIONS"
                        },
                        {
                            label: "messages",
                            path: "/messages",
                            icon: 'fa-table',
                            permission: "VIEW_MESSAGES"
                        },
                        {
                            type: 'break'
                        },
                        {
                            label: "weekly_plans",
                            path: "/weekly-plans",
                            icon: 'fa-newspaper',
                            permission: "VIEW_WEEKLYPLANS"
                        },
                        {
                            label: "time_tables",
                            path: "/time-tables",
                            icon: 'fa-table',
                            permission: "VIEW_TIMETABLES"
                        },
                        {
                            label: "worksheets",
                            path: "/worksheets",
                            icon: 'fa-file-alt',
                            permission: "VIEW_WORKSHEETS"
                        },
                        {
                            label: "exams",
                            path: "/exams",
                            icon: 'fa-file-alt',
                            permission: "VIEW_EXAMS"
                        },
                        {
                            type: 'break'
                        },
                        {
                            label: "roles",
                            path: "/roles",
                            icon: 'fa-user-lock',
                            permission: "VIEW_ROLES"
                        },
                        {
                            label: "users",
                            path: "/users",
                            icon: 'fa-users',
                            permission: "VIEW_USERS"
                        }
                    ],
                teacherLinks: [
                        {
                            label: "time_tables",
                            path: "/time-tables",
                            icon: 'fa-table',
                            permission: ""
                        },
                        {
                            label: "messages",
                            path: "/messages",
                            icon: 'fa-table',
                            permission: ""
                        },
                    ]
            };
        },
        computed: {
            links() {
                if (this.hasRole(this.ROLES.TEACHERS)) {
                    return this.teacherLinks;
                } else{
                    return this.superAdminLinks;
                }

            }
        }
    };

</script>
